import * as wizeMobileApi from '@wize-mobile-api';
import { Currency } from '@qvs/core';

export class CurrenciesMapper {
  public static fromWizeListCurrencies(currencies: wizeMobileApi.Currency[]): Currency[] {
    return currencies
      ? currencies.map((currency) => ({
          currency: currency.id,
          decimals: currency.decimals,
          label: currency.description,
          ranking: currency.ranking
        }))
      : undefined;
  }
}
